define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Registrer enda en bruker",

    'incrowd_stats.num_responders': "{{num}} profesjonelle helseansatte",
    'incrowd_stats.num_answers': "{{num}} spørsmål besvart",
    'incrowd_stats.time_to_complete': "{{num}} minutter på å besvare en gjennomsnittlig undersøkelse",

    // INCROWD
    'incrowd.about': "Om",
    'incrowd.contact': "Kontakt",
    'incrowd.press': "Presse",
    'incrowd.careers': "Karriere",
    'incrowd.terms': "Vilkår",
    'incrowd.t_and_c': "Vilkår og betingelser",
    'incrowd.faq': "Ofte stilte spørsmål",
    'incrowd.privacy': "Personvern",
    'incrowd.copyright': "{{year}} InCrowd Inc, alle rettigheter forbeholdes",
    'incrowd.blog': "Blogg",
    'incrowd.support': "Support",
    'incrowd.info.ios': "Visste du at leger i InCrowd-nettverket nå kan sende spørsmål direkte til kollegaene sine? Prøv det nå ved å bruke <InCrowd iOS Appen>!",
    'incrowd.refer': "Liker du å ta undersøkelsene våre? <Henvis en venn> i dag for å registrere deg hos oss og begge vil få 10 USD (eller tilsvarende). Når kollegaen svarer på en undersøkelse vil de få en bonus!",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "Mikroundersøkelser,",
    'getstarted.encourage.title.two': "massiv innflytelse",
    'getstarted.encourage.subtitle': "Bli med tusenvis av medisinske fagpersoner i å ha en innflytelse på utviklingen av nye produkter og pasientbehandlinger via enkle mikrospørreundersøkelser, i tillegg til å få betalt for det!",
    'getstarted.encourage.redirect_to_solutions': "Ikke profesjonell helsearbeider, men vil likevel lære mer om InCrowd?",
    'getstarted.actions.title': "Er du en kvalifisert medisinsk fagperson?",
    'getstarted.actions.subtitle': "Registrer deg i dag og begynn å tjene penger på å besvare mikrospørreundersøkelser som fokuserer på helserelaterte produkter og tjenester",
    'getstarted.button.continue': "Kom i gang",
    'getstarted.referral': "Meld deg inn og begynn å tjene penger på spørreundersøkelser i tillegg til bonus for å verve en venn fra %{{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "Vi trenger noen få detaljer for å etablere kontoen din.",
    'details.profile_details': "Profildetaljer",
    'details.address_information': "Adresseiformasjon",
    'details.professional_info': "Profesjonell informasjon",
    'details.heading.finally': "…og til slutt",
    'details.how_receive_surveys': "Hvordan foretrekker du å motta spørreundersøkelsene?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "Det grunnleggende",
    'professionchoice.encourage.subtitle': "Ser du ikke yrket ditt? Si ifra <her> for å sikre at du blir varslet når vi legger til yrket ditt.",
    // AUTHENTICATION INFORMATION (step 2a)
    'authentication.encourage.title': "Hvem er du?",
    'authentication.encourage.subtitle': "InCrowd må bekrefte identiteten din, men vi vil aldri avsløre eller distribuere dine personlige opplysninger til tredjeparter.",
    'authentication.actions.select_notifications': "Hvelg hvordan du vil foretrekke å motta undersøkelser fra oss",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Vennligst vent mens vi validerer informasjonen din",
    'validation.please_answer': "Vennligst besvar følgende spørsmål slik at vi kan validere dine personlige opplysninger",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Bekreftelse",
    'confirmation.validation_success.subtitle': "Registreringen din er fullført. Velkommen til InCrowd! Du vil snart motta en bekreftelse via epost og/eller tekstmelding. Takk for at du er med!",
    'confirmation.validation_error.title': "Mer informasjon kreves",
    'confirmation.validation_error.subtitle': "Beklager, %{userFirstName}, dine personlige opplysninger kunne ikke valideres.",
    'confirmation.actions_title': "Hva skjer nå?",
    'confirmation.go_to_your_profile': "Gå til profilen din",
    'confirmation.validation_success.actions_subtitle': "Du vil begynne å motta våre 5-10 minutter lange mikroundersøkelser etter et par dager, via epost eller tekstmelding. Har du ikke valgt å ta imot undersøkelser via tekstmelding ennå? Du kan endre kommunikasjonsinnstillingene når som helst fra din InCrowd-profil.",
    'confirmation.validation_error.actions_subtitle': "Bruk popup-chatten nederst til høyre på skjermen for å snakke med InCrowd, slik at vi kan løse eventuelle problemer.",
    'confirmation.referral.info.1': "Innen %{payoutBusinessDays} arbeidsdager etter at du har fullført din andre spørreundersøkelse, vil du og personen som vervet deg, <vil begge motta %{currency}%{referralBonusAmount}>. %{currency}%{referralBonusAmount} legges til deres bonuskontoer. Du kan logge deg inn på din <profil> når som helst for å oppdatere dine innstillinger for preferanser, få en oversikt over belønninger eller se alle åpne spørreundersøkelser du har blitt invitert til.",
    'confirmation.referral.info.2': "Lurer du på noe? <Chat med oss>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Er du kvalifisert?",
    'regftr.markets.accepting': "InCrowd Answers aksepterer for øyeblikket:",
    'regftr.peers.title': "Likemenn",
    'regftr.peers.subtitle': "Sammenlign svarene dine med de av dine likemenn og lær fra deres svar.",
    'regftr.invites.title': "Invitasjoner",
    'regftr.invites.subtitle': "Få invitasjoner til nye spørreundersøkelser via e-post eller mobiltelefonen for å øke fortjenesten din.",
    'regftr.earnings.title': "Fortjeneste",
    'regftr.earnings.subtitle': "Administrer og hold rede på din fortjeneste og informasjon om betalinger.",
    'regftr.stats.title': "Statistikk",
    'regftr.stats.subtitle': "Få tilgang til et instrumentbord med all din informasjon om undersøkelser og brukeropplysninger.",

    'contextual_help.sms': "Du mottar SMS-varsel om åpne mikroundersøkelser. SMS-en gjør at du kan besvare undersøkelsen raskere og opparbeide enda flere premier. Informasjonen din er privat og brukes bare for invitasjoner til å delta i undersøkelser.",
    // USER
    'user(s)': "Bruker |||| Brukere",
    'user.login': "Logg inn",
    'user.logout': "Logg ut",
    'user.register': "Registrer",
    'user.invitations': "Invitasjoner",
    'user.email': "E-post",
    'user.pass_word': "Passord",
    'user.mobile': "Mobil",
    'user.mobile.hint': "Inkluder landkode (+%{phoneCode} for %{countryName})",
    'user.title': "Tittel",
    'user.title_with_example': "Tittel (dvs. Dr. Fru,Herre)",
    'user.first_name': "Fornavn",
    'user.last_name': "Etternavn",
    'user.middle_name': "Mellomnavn",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "En bruker",
    'user.anonymous_admin': "Admin",
    'user.dashboard': "Kontrollpanel",
    'user.profile': "Profil",
    'user.profile.picture.upload': "Last opp profilbilde",
    'user.profile.picture.change': "Endre",
    'user.primary_lang': "Hovedspråk",
    'user.primary_lang?': "Hva er ditt hovedspråk?",
    'user.survey_langs?': "Hvilke språk snakker du flytende?",
    'user.notify_email': "Varsle på e-post",
    'user.notify_mobile': "Varsle på mobil",
    'user.contact_support': "Kontakt support",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Vennligst <contact us>.",
    'user.profession': "Yrke",
    'user.profession?': "Hva er yrket ditt?",
    'user.join_now': "Registrer nå",
    'user.welcome_back': "Velkommen tilbake!",
    'user.not_a_member?': "Ikke et medlem enda?",
    'user.accept_terms': "Aksepter vilkår",
    'user.accept_terms.yes': "Jeg aksepterer <vilkår og betingelser>",
    'user.remember_me': "Husk meg på denne enheten",
    'user.time_zone': "Tidssone",
    'user.payment.policy': "Hver gang du oppnår %{currency}25 i belønning, får du et varsel og kan velge fra våre utbetalingsmuligheter via din InCrowd-profil. Spørsmål? Du får kontakt via chattevinduet nedenfor.",
    'user.country.live_work?': "Hvilket land bor du og jobber i?",
    // FORMS
    'form.button.back': "Tilbake",
    'form.button.next': "Neste",
    'form.button.cancel': "Avbryt",
    'form.button.submit': "Send inn",
    'form.button.continue': "Fortsett",
    'form.button.close': "Lukk",
    'form.button.go!': "Gå!",
    'form.button.complete!': "Fullfør nå!",
    'form.button.update': "Oppdater",
    'form.button.finish': "Fullfør",
    'form.button.search': "Søk",
    'form.button.end': "Slutt",
    'form.search.no_matches': "Ingen treff funnet",
    'form.confirm_email': "Bekreft e-post",
    'form.confirm_pass_word': "Bekreft passord",
    'form.required_fields': "Påkrevde felt",
    'form.nothing_selected': "Ingenting er valgt",
    'form.confirm_field': "Bekreft %{formFieldLabel}",
    'form.choice.n/a': "IA",
    'form.choice.yes': "Ja",
    'form.choice.no': "Nei",
    'form.choice.blank_for_all': "La feltet stå tomg for å velge alle",
    'form.choices.select_all': "Velg alle",
    'form.choices.deselect_all': "Velg ingen",
    'form.field.private': "Privat felt",

    // USER ERRORS
    'user.error.dup_email': "En annen bruker er allerede registrert med den gitte e-postadressen. <Logge inn i stedet?>",
    'user.error.dup_sms': "En annen bruker er allerede registrert med det gitte mobilnummeret",

  }
})
